import { createAsyncThunk } from '@reduxjs/toolkit'
import CommentAPI from '@api/comment_web_api.js'
import { serializableError } from '@utils/serializable_error.ts'
import { handleFetchTimelineCommentsSuccess } from './ServerActions.js'

export const fetchTimelineCommentsById = createAsyncThunk(
  'timeline_comments/fetchTimelineCommentsById',
  async (object, thunkAPI) => {
    const { timelineId } = object
    const { dispatch, rejectWithValue } = thunkAPI
    try {
      const response = await CommentAPI.fetchTimelineComments(timelineId)
      dispatch(handleFetchTimelineCommentsSuccess(response, timelineId))
      // Note: Anything returned here becomes the payload of fulfilled action
    } catch (error) {
      return rejectWithValue(serializableError(error))
    }
  }
)
